<template>
<div class="login-container">
  <div class="login-wrapper">
    <section class="login-content">
      <h1 class="mb-5">{{$t('login.login')}}</h1>
      <!-- errors -->
      <div v-if="message">
        <div class="alert">
          <button type="button" v-on:click="resetResponse" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button> {{message}}
        </div>
      </div>
      <div v-if="error">
        <div class="alert">
          <button type="button" v-on:click="clearError" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button> {{error}}
        </div>
      </div>
      <!-- フォーム部分 -->
      <v-form class="mb-2">
        <v-text-field
          color="white"
          class="mb-2"
          :label="$t('user-params.username')"
          v-model="username"
          :rules="usernameRules"
          required
        >
        </v-text-field>
        <v-text-field
          color="white"
          :label="$t('user-params.password')"
          v-model="password"
          :rules="passwordRules"
          required
          :append-icon="passwordVisible? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (passwordVisible = !passwordVisible)"
          :type="passwordVisible ? 'text':'password'"
          autocomplete="password">
        </v-text-field>
        <v-btn class="mb-3" color="blue" dark @click="checkCreds">{{$t('login.login')}}</v-btn>
      </v-form>

      <div>
        <router-link :to="{ name: 'ResetPassword' }" class="reset_pass">{{ $t("login.lost") }}</router-link><br>
        <div v-if="isHarps4">
          <br>
          <router-link :to="{ name: 'Signup' }" class="reset_pass">{{ $t("login.link_to_signup") }}</router-link>
        </div>
      </div>
    </section>
      <login-footer/>
  </div>
</div>
</template>

<script>
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */
import LoginFooter from '@/pages/LoginFooter'
import utils from '@/utils/utils'

export default {
  name: 'login',
  components: {
    LoginFooter
  },
  data () {
    return {
      username: '',
      password: '',
      response: '',
      error: '',
      submitted: false, // submitフラグ
      name: '',
      passwordVisible: false,
      usernameRules: [
        (v) => !!v || this.$t('login.vali-username-blank')
      ],
      passwordRules: [
        (v) => !!v || this.$t('login.vali-password-blank')
      ]
    }
  },
  computed: {
    message () {
      if (this.$store.getters.message !== null) {
        this.response = this.$store.getters.message.message
        this.$store.commit('SET_MESSAGE', null)
      }
      return this.response
    },
    isHarps4(){
      return utils.isHarps4()
    }
  },
  methods: {
    checkCreds () {
      this.submitted = true // ボタン無効化
      this.username = this.username.trim()
      const {
        username,
        password
      } = this
      this.resetResponse()
      this.clearError()

      this.$store.dispatch('login', { username, password }) // ログイン
      .then(() => this.$store.dispatch('getme')) // ログインユーザの情報を取得
      .then(() => this.$store.dispatch('getSettingParam')) // 設定パラメータを取得
      .then(() => this.$router.push(this.$store.getters.startPage)) // home へ遷移
      .catch(err => {
        this.submitted = false // ボタン有効化
        console.error(err)
        if (err.code !== undefined) {
          console.error(err.code)
          if (err.code === 'NewPasswordRequired') {
            this.$router.push({
              name: 'Activate'
            })
          }
        }
        if (err.message) {
          if (err.code === 'UserNotFoundException' ||
              err.code === 'NotAuthorizedException') {
            this.error = this.$t('login.incorrect')
          } else {
            this.error = err.message
          }
        } else {
          this.error = err
        }
      })
    },
    resetResponse () {
      this.response = ''
    },
    clearError () {
      this.error = ''
    }
  }
}
</script>

<style>
/* ログイン時にくるくるが見えにくいので修正 */

.pace .pace-progress {
  background-color: #FFD54A;
  height: 3px;
}

.pace .pace-progress-inner {
  box-shadow: 0 0 10px #FFD54A, 0 0 5px #FFD54A;
}

.pace .pace-activity {
  border-top-color: #FFD54A;
  border-left-color: #FFD54A;
}
</style>



// WEBPACK FOOTER //
// Login.vue?3cba9dd6